// extracted by mini-css-extract-plugin
export default {"returnsAndExchanges":"Mo-z","returnHeader":"No-z","titleAndReturnPolicyLink":"Oo-z","ourReturnPolicy":"Po-z","boxes":"Qo-z","illustration":"Ro-z","address":"So-z"};